import { CART_LISTENER_NAME } from "@/context/cart";
import { Url } from "@/helpers/url";
import { useServices } from "@/services-context";
import { Gtag } from "@/services/gtag";
import { getEnv } from "@/util/env";
import { useCallback } from "preact/hooks";

const buildCheckoutUrl = (cartId: string, lang: string, country: string) => {
    return `${window.location.origin}/checkout?source=b2c&id=${cartId}&lang=${lang}&country=${country}`;
};

export const useCartCommons = (params: {}) => {
    const {
        cart,
        parameters
    } = useServices([CART_LISTENER_NAME]);

    const country = parameters.parameters.country;
    const language = parameters.parameters.language;

    const goToCheckout = useCallback((e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();

        if (cart.id) {
            const url = buildCheckoutUrl(cart.id, language, country);

            Gtag.pushEvent("сheckout_сlick", "");
            Url.navigateOutside(url);
        }
    }, [cart?.id, language, country]);

    return { goToCheckout };
};